import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from '../API/api.service';

/**
 * S237 P493 sheet 1. Which add-ons are switched on for the logged-in user's company.
 * Server: POST addons/mine (company from the login, never the screen).
 * Not cached on purpose: a logout and login as another company happens without a page load.
 * On any error the answer is [] - the screen then hides add-on doors, the safe direction.
 * The real lock is on the server (policy connectionsOnly); this only tidies the screen.
 */
@Injectable({
  providedIn: 'root'
})
export class AddonService {

  constructor(private apiService: ApiService) { }

  mine(): Observable<string[]> {
    return this.apiService.post('addons/mine', {}).pipe(
      map((r: any) => Array.isArray(r) ? r : []),
      catchError(() => of([]))
    );
  }
}
